// extracted by css-extract-rspack-plugin
export default {"dragging":"Sortable-module__dragging___BYIGn"};